import type { Bundle, CompanyBundle, Coverage, PersonalBundle } from '../types/Policy';

export const hasAnyActiveCoverage = (policy: Bundle) => policy.coverages.some(isActiveCoverage);

export const isActiveCoverage = (coverage: Coverage): boolean => {
  return coverage.status !== 'cancelled';
};

export const isPersonalPolicyData = (policyData: Bundle): policyData is PersonalBundle =>
  policyData.type === 'personal';

export const isCompanyPolicyData = (policyData: Bundle): policyData is CompanyBundle => {
  return policyData.type === 'company';
};
